<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Partner List</h2>
          </div>
          <div class="body pt-0">
            <div
              class="chart-top-action d-lg-flex justify-content-between py-3"
            >
              <div class="d-md-flex justify-content-between">
                <div class="mr-0 mr-md-3 action-top-search">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search partner"
                      aria-label="Search partner"
                      aria-describedby="search-partner"
                      v-model="searchText"
                      v-on:keyup.enter="refreshPartnerTable"
                    />
                    <div
                      class="input-group-append"
                      @click="refreshPartnerTable()"
                    >
                      <span class="input-group-text" id="search-mail">
                        <i class="icon-magnifier"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="fliter-main mr-auto mt-3 mt-md-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <div
                class="d-md-flex justify-content-between mt-lg-0 mt-md-3 mt-0"
              >
                <div
                  class="payment-dropdown d-flex flex-row-reverse ml-lg-3 mt-3 mt-sm-0"
                >
                  <b-button
                    size="lg"
                    variant="primary btn-mw"
                    @click="addPartner()"
                  >
                    Add Partner
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </div>
              </div>
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div
                  class="d-flex flex-column justify-content-between pt-3 pr-3 pl-3 middleware-list-wrapper"
                >
                  <div
                    v-for="(item, index) in advanceFilters"
                    :key="index"
                    class="d-flex middleware-list"
                  >
                    <div
                      class="form-group form-select single-multiselect m-0 column-1"
                    >
                      <span class="float-label w-100">
                        <label>Select Field</label>
                        <multiselect
                          placeholder=""
                          v-model="item.field"
                          :show-labels="false"
                          :options="filterField"
                          label="name"
                          :searchable="true"
                          :allowEmpty="false"
                          @select="fieldsUpdate"
                        ></multiselect>
                      </span>
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group m-0 column-2"
                      v-if="
                        item.field &&
                        (item.field.id == 'partnername' ||
                          item.field.id == 'companyname')
                      "
                    >
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.search"
                        :placeholder="'Enter ' + item.field.name"
                      />
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'country'"
                    >
                      <span class="float-label w-100">
                        <label>Select Dest. Country</label>
                        <v-select
                          :options="countryList"
                          multiple
                          v-model="item.country"
                          :get-option-label="(option) => option.name"
                        >
                          <template #option="option">
                            <div class="option__desc">
                              <span
                                :class="
                                  'flag-icon flag-icon-' +
                                  option.isoCode.toLowerCase() +
                                  ' fi-md fi-round '
                                "
                              ></span>
                              <span class="option__title">
                                {{ option.name }}
                              </span>
                            </div>
                          </template>
                        </v-select>
                      </span>
                    </div>
                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'date'"
                    >
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">From</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.from"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">To</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.to"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                    </div>
                    <div v-if="advanceFilters.length > 1" class="column-3">
                      <b-button
                        class="fliter-btn btn-lg"
                        variant="outline-danger"
                        @click="removeFilter(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-left">
                    <b-button
                      class="fliter-btn w-auto"
                      variant="outline-primary"
                      @click="appendFilter"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more filters
                    </b-button>
                  </div>
                </div>
                <div class="pb-3 pr-3 text-right">
                  <button
                    class="btn btn-primary w-auto"
                    @click="applyTestfilter"
                  >
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-danger w-auto ml-3"
                    @click="clearTestfilter"
                  >
                    Cancel/Clear
                  </button>
                </div>
              </b-collapse>
            </div>
            <div
              class="filter-list-area d-flex flex-wrap align-items-center mb-1"
              v-if="displayFilters && displayFilters.length > 0"
            >
              <i
                class="fa fa-filter text-primary mr-1 mb-2"
                aria-hidden="true"
              ></i>
              <div
                class="mb-1"
                v-for="(item, index) in displayFilters"
                :key="index"
              >
                <label
                  class="font-14 line-height-18 mb-0 ml-2"
                  v-if="
                    index == 0 ||
                    item.filter_field != displayFilters[index - 1].filter_field
                  "
                >
                  {{ item.field_name + ":" }}
                </label>
                <!-- Only for country filter-->
                <template v-if="item.filter_field == 'country'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="country in item.filter_value"
                    :key="country"
                  >
                    {{
                      countryList.filter(
                        (data) => data.countryid === country,
                      )[0].countryname
                    }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="removeCountry(country, item.filter_field, index)"
                    ></i>
                  </span>
                </template>
                <!-- Only for Date -->
                <template v-else-if="item.filter_field == 'date'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(date, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="date">
                      {{ indexValue + ": " + date }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removeDate(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>
                <!-- Other filter -->
                <span class="badge badge-warning-solid" v-else>
                  {{ item.filter_value ? item.filter_value : "-" }}
                  <i
                    class="fa fa-close cursor-pointer ml-1"
                    @click="removeFilter(index)"
                  ></i>
                </span>
              </div>
              <span class="text-danger cursor-pointer" @click="clearTestfilter">
                Clear all
              </span>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <b-table
              ref="partnertable"
              responsive
              hover
              table-class="js-basic-example table-custom mb-0 border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(country)="data">
                <div class="align-items-center d-flex">
                  <span :class="data.value.flagClass"></span>
                  <span
                    class="ml-2"
                    v-b-tooltip.hover
                    :title="data.item.country.name"
                  >
                    {{ data.item.country.isocode.toUpperCase() }}
                  </span>
                </div>
              </template>
              <template #cell(status)="data">
                <select
                  class="btn btn-filter badge"
                  v-model="data.item.status.name"
                  :class="data.value.class"
                  @change="onChangestatus($event, data.index + 1)"
                >
                  <option value="">Select Option</option>
                  <option
                    v-for="(option, index) in statusoption"
                    :key="index"
                    :value="option.name"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </template>
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item>Active</b-dropdown-item>
                  <b-dropdown-item @click="editpartner()">Edit</b-dropdown-item>
                  <b-dropdown-item @click="manageUsers()">
                    Manage Users
                  </b-dropdown-item>
                  <b-dropdown-item @click="showAlert">Delete</b-dropdown-item>
                  <b-dropdown-item>Partner Login</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { toastFunction } = require("@/plugins/toast");
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
const { sweetAlertFunction } = require("@/plugins/sweetalert2");
import "vue-select/dist/vue-select.css";
const moment = require("moment");
// import { GET_PARTNER_LIST } from "../../../store/actions.type.js";
import { mapState, mapGetters } from "vuex";
export default {
  name: "PartnerListComponent",
  components: {
    BreadCrumb,
    Multiselect: () => import("vue-multiselect"),
    Datepicker: () => import("vuejs-datepicker"),
    "v-select": () => import("vue-select"),
    "main-loader": LoaderComponent,
  },
  data() {
    return {
      options: [
        { value: "pending", text: "Pending" },
        { value: "approved", text: "Approved" },
        { value: "rejected", text: "Rejected" },
      ],

      items: [
        {
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          name: "Akosua Nunoo",
          email: "akosuatemaah1236@hotmail.com",
          mobile: "+447799691752",
          regdate: "2019-07-09 15:04:00",
          compname: "ABURI GIRLS ...",
          status: { name: "Active", class: "badge-info" },
          action: "",
        },
        {
          country: {
            flagClass: "flag-icon flag-icon-gh fi-lg fi-round",
            isocode: "gh",
            name: "Ghana",
          },
          name: "Antonio Bortoletto",
          email: "abortoletto@f2b.com.br",
          mobile: "+233263456785",
          regdate: "2019-07-09 15:04:00",
          compname: "ALEXpay - Allied ...",
          status: { name: "Approve", class: "badge-success" },
          action: "",
        },
        {
          country: {
            flagClass: "flag-icon flag-icon-us fi-lg fi-round",
            isocode: "us",
            name: "United States",
          },
          name: "Akosua Nunoo",
          email: "akosuatemaah1236@hotmail.com",
          mobile: "+447799691752",
          regdate: "2019-07-09 15:04:00",
          compname: "ABURI GIRLS ...",
          status: { name: "Reject", class: "badge-danger" },
          action: "",
        },
        {
          country: {
            flagClass: "flag-icon flag-icon-gb fi-lg fi-round",
            isocode: "gb",
            name: "United Kingdom",
          },
          name: "Antonio Bortoletto",
          email: "abortoletto@f2b.com.br",
          mobile: "+233263456785",
          regdate: "2019-07-09 15:04:00",
          compname: "ALEXpay - Allied ...",
          status: { name: "Inactive", class: "badge-warning" },
          action: "",
        },
      ],

      fields: [
        {
          key: "country",
          label: "Country",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "name",
          label: "Partner Name",
          sortable: false,
          thClass: "th_sortfix",
        },
        { key: "compname", label: "Company Name" },
        {
          key: "regdate",
          label: "Reg. Date/Time",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "email",
          label: "Email",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "mobile",
          label: "Mobile",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "status",
          label: "Status",
          sortable: false,
          thClass: "th_sortfix",
        },
        { key: "action", label: "Action" },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      isVisibleFilter: false,
      displayFilters: [],
      statusoption: [
        { name: "Active", class: "badge-info" },
        { name: "Approve", class: "badge-success" },
        { name: "Reject", class: "badge-danger" },
        { name: "Inactive", class: "badge-warning" },
      ],
      filterField: [
        { id: "partnername", name: "Partner Name", $isDisabled: false },
        { id: "companyname", name: "Company Name", $isDisabled: false },
        { id: "country", name: "Country", $isDisabled: false },
        { id: "date", name: "Date", $isDisabled: false },
      ],
      advanceFilters: [
        {
          field: {
            id: "partnername",
            name: "Partner Name",
            $isDisabled: false,
          },
          search: "",
          country: [],
          date: {
            from: "",
            to: "",
          },
        },
      ],

      totalRows: 0,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: 100 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      searchText: "",
      filterBy: "",
      filterValue: "",
      condition: "",
    };
  },
  methods: {
    onChangestatus(event, index) {
      var classVar = "";
      return this.items.map((item, i) => {
        if (index == i + 1) {
          if (event.target.value == "Approve") {
            classVar = "badge-success";
          } else if (event.target.value == "Inactive") {
            classVar = "badge-warning";
          } else if (event.target.value == "Active") {
            classVar = "badge-info";
          } else if (event.target.value == "Reject") {
            classVar = "badge-danger";
          }
          item.status.class = classVar;
        }
      });
    },
    // for openFilters
    openFilters() {
      if (this.advanceFilters == 0) {
        this.advanceFilters = [
          {
            field: {
              id: "partnername",
              name: "Partner Name",
              $isDisabled: true,
            },
            search: "",
            country: [],
            date: {
              from: "",
              to: "",
            },
          },
        ];
      }
      this.isVisibleFilter = !this.isVisibleFilter;
    },
    // apply filter
    applyTestfilter() {
      let params = [];
      this.advanceFilters.map((item) => {
        let data = {
          filter_field: item.field.id,
          field_name: item.field.name,
        };
        if (item.field.id == "partnername" || item.field.id == "companyname") {
          data.filter_value = item.search;
        }
        if (item.field.id == "country") {
          //|| item.field.id == "sourcecountry"
          let countries = [];
          item.country.map((country) => {
            countries.push(country.countryid);
          });
          data.filter_value = countries;
        }
        if (item.field.id == "date") {
          data.filter_value = {
            from: item.date.from
              ? moment(item.date.from).format("DD-MM-YYYY")
              : "",
            to: item.date.to ? moment(item.date.to).format("DD-MM-YYYY") : "",
          };
        }
        params.push(data);
      });
      this.isVisibleFilter = false;
      this.$cookies.set("partner-list-filter", params);
      this.displayFilters = this.$cookies.get("partner-list-filter");
      console.log("params", params);
    },
    // clear filter
    clearTestfilter() {
      this.advanceFilters = [
        {
          field: { id: "partnername", name: "Partner Name", $isDisabled: true },
          search: "",
          country: [],
          date: {
            from: "",
            to: "",
          },
          amount: {
            type: "",
            value: "",
          },
        },
      ];
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.displayFilters = [];
      this.isVisibleFilter = false;
      this.$cookies.set("partner-list-filter", this.displayFilters);
    },
    // append filters
    appendFilter() {
      this.advanceFilters.map((item) => {
        this.filterField.filter(
          (data) => data.id == item.field.id,
        )[0].$isDisabled = true;
      });
      if (this.filterField.filter((data) => data.$isDisabled == false)[0]) {
        this.advanceFilters.push({
          field: this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0],
          search: "",
          country: [],
          date: {
            from: "",
            to: "",
          },
        });
        this.filterField.filter(
          (data) => data.$isDisabled == false,
        )[0].$isDisabled = true;
      }
    },
    // update fields of filters
    fieldsUpdate() {
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        this.filterField.filter(
          (data) => data.id == item.field.id,
        )[0].$isDisabled = true;
      });
    },
    // to remove filters
    removeFilter(index) {
      this.filterField.filter(
        (data) => data.id == this.advanceFilters[index].field.id,
      )[0].$isDisabled = false;
      this.advanceFilters.splice(index, 1);
      this.displayFilters.splice(index, 1);
      this.$cookies.set("partner-list-filter", this.displayFilters);
    },
    // remove date filters
    removeDate(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].date[indexValue] = "";

      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.from == "" && temp.to == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == "date")[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.$cookies.set("partner-list-filter", this.displayFilters);
    },
    // remove country filters
    removeCountry(country, field, filterindex) {
      let temp = this.displayFilters.filter(
        (data) => data.filter_field == field,
      )[0].filter_value;
      let countries = [];
      let countriesobj = [];
      temp.map((item) => {
        if (item != country) {
          countries.push(item);
          countriesobj.push(
            this.countryList.filter((data) => data.countryid === item)[0],
          );
        }
      });
      if (countries.length > 0) {
        this.displayFilters.filter(
          (data) => data.filter_field == field,
        )[0].filter_value = countries;
      } else {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == field)[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.advanceFilters.map((item, index) => {
        if (item.field.id == field) {
          this.advanceFilters[index].country = countriesobj;
        }
      });
      this.$cookies.set("partner-list-filter", this.displayFilters);
    },
    cookieFilters() {
      this.displayFilters = this.$cookies.get("partner-list-filter");
      let filters = [];
      if (this.displayFilters && this.displayFilters.length > 0) {
        this.displayFilters.map((item) => {
          this.filterField.filter(
            (data) => data.id == item.filter_field,
          )[0].$isDisabled = true;
          if (
            item.filter_field == "partnername" ||
            item.filter_field == "companyname"
          ) {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: item.filter_value,
              country: [],
              date: {
                from: "",
                to: "",
              },
            });
          }
          if (item.filter_field == "date") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: "",
              country: [],
              date: {
                from: item.filter_value.from,
                to: item.filter_value.to,
              },
            });
          }
          if (item.filter_field == "country") {
            let countries = [];
            item.filter_value.map((country) => {
              countries.push(
                this.countryList.filter(
                  (data) => data.countryid === country,
                )[0],
              );
            });
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: "",
              country: countries,
              date: {
                from: "",
                to: "",
              },
              amount: {
                type: "",
                value: "",
              },
            });
          }
        });
        this.advanceFilters = filters;
      }
    },
    onChange(event, index) {
      var classVar = "";
      return this.items.map((item, i) => {
        if (index == i + 1) {
          if (event.target.value == "accept") {
            classVar = "btn-outline-success";
          } else if (event.target.value == "cancel") {
            classVar = "btn-outline-danger";
          }
          item.dropdawn.class = classVar;
        }
      });
    },

    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = e.target.value;
        }
      }
    },

    showAlert() {
      //common options for sweetalert
      var data = {
        icon: "warning",
        title: "Are you sure",
        text: `You won't be able to revert this!`,
        confirmButtonText: "Yes, delete it!",
        showCancelButton: true,
      };

      //if action is confirmed
      var confirmActions = {
        loader: this.$refs.loader,
        toastMessage: toastFunction,
      };

      //call function with arg
      sweetAlertFunction.displayAlertPopUp(data, confirmActions);
    },

    refreshPartnerTable() {
      this.$refs.partnertable.refresh();
    },

    resetFilterValue() {
      ((this.filterBy = ""),
        (this.filterValue = ""),
        (this.condition = ""),
        this.refreshPartnerTable());
    },

    addPartner() {
      // console.log('Create fund');
      this.$router.push({ path: "/partner/add" });
    },
    editpartner() {
      this.$router.push({ path: "/partner/edit" });
    },
    manageUsers() {
      this.$router.push({ path: "/partner/users" });
    },
    getPartnerList() {
      // this.$store.dispatch(GET_PARTNER_LIST).then((response) => {
      //     console.log(response)
      // });
    },
  },
  watch: {
    countryList() {
      this.cookieFilters();
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    this.getPartnerList();
    if (this.countryList.length) {
      this.cookieFilters();
    }
    setTimeout(() => {
      this.cookieFilters();
    }, 1000);
  },
  computed: {
    ...mapGetters(["isLoading", "countryList"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
